// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--dFY77";
export var Container = "styles-module--Container--Bgw1E";
export var Header = "styles-module--Header--ql10A";
export var Menu = "styles-module--Menu--FKj-Q";
export var Menu_Copyright = "styles-module--Menu_Copyright--ti308";
export var Menu_List = "styles-module--Menu_List--xehbx";